export default "__VITE_ASSET__ba825738__"